<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Clientes del Negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :search="search"
        :headers="headers"
        :items="clientesList"
        :loading="loading"
      >
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="info"
                  min-width="0"
                  v-on="on"
                  small
                  @click="verCliente(item)"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Ver</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="purple"
                  min-width="0"
                  v-on="on"
                  small
                  @click="direcciones(item)"
                >
                  <v-icon small>mdi-home</v-icon>
                </v-btn>
              </template>
              <span>Direcciones</span>
            </v-tooltip>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog
      v-if="!!clienteObj"
      v-model="clienteDialog"
      max-width="800"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card>
          <v-card-title>
            Editar Cliente {{ clienteObj.nombreLocal }}
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Canal de registro"
                  disabled
                  v-model="clienteObj.canalRegistro"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Nombre en la web"
                  disabled
                  v-model="clienteObj.displayName"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Email"
                  disabled
                  v-model="clienteObj.email"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  disabled
                  label="Teléfono web verificado"
                  v-model="clienteObj.phoneNumber"
                  messages="Con este teléfono se ha logueado el usuario"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="Nombre" v-model="clienteObj.localNombre" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="1º Apellido"
                  v-model="clienteObj.localApellido1"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="2º Apellido"
                  v-model="clienteObj.localApellido2"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="NIF" v-model="clienteObj.localNif" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Teléfono"
                  v-model="clienteObj.localTelefono"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="clienteDialog = false">Cancelar</v-btn>
            <v-spacer />
            <v-btn
              disabled
              color="primary"
              @click="save"
              :loading="guardarBotonLoading"
              >Guardar</v-btn
            >
          </v-card-actions>
          <v-card-text> </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
    <!-- dialogo direcciones-->
    <v-dialog v-model="direccionesDialog" v-if="clienteObj" max-width="600">
      <v-card>
        <v-card-title>
          Direcciones Cliente {{ clienteObj.nombreLocal }}
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-list-item
              :value="dir.id"
              v-for="(dir, i) in clienteObj.direcciones"
              :key="i"
            >
              <!-- <v-list-item-title>{{ dir }}</v-list-item-title> -->
              <v-list-item-title
                >{{ dir.calle }} {{ dir.numero }}</v-list-item-title
              >
              <v-card-text
                >{{ dir.adicional }} {{ dir.adicional ? "," : "" }}
                {{ dir.municipio }} {{ dir.cp }}
                {{ dir.provincia }}</v-card-text
              >
            </v-list-item>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="info" dark @click="direccionesDialog = false"
            >Cerrar</v-btn
          >
          <v-spacer />
        </v-card-actions>
        <v-card-text> </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mostrarIdioma, idToTexto } from "@/utils/utils.js";
export default {
  data() {
    return {
      direccionSeleccionada: null,
      direccionesDialog: false,
      guardarBotonLoading: false,
      clienteObj: null,
      clienteDialog: false,
      loading: false,
      search: "",
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "displayName",
        },
        {
          sortable: false,
          text: "Telefono",
          value: "phoneNumber",
        },
        {
          sortable: false,
          text: "Restaurantes",
          value: "restaurantesMostrar",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    isAdmin() {
      return this.role == "admin";
    },
    isBossNegocio() {
      return this.role == "boss_negocio";
    },
    clientesList() {
      return this.clientes.map((c) => {
        return {
          ...c,
          restaurantesMostrar: c.restaurantes
            .map((e) => idToTexto(e))
            .join(", "),
        };
      });
    },
    ...mapGetters({
      negocio: "app/negocioGestObj",
      role: "auth/role",
    }),
    ...mapState({
      clientes: (state) => state.negocios.clientesNegocio,
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    subtitulo() {
      return "Listado de clientes de " + this.negocio.nombre;
    },
    formTitle() {
      return this.isEdit ? "Editar Cliente" : "Nuevo Cliente";
    },
    accion() {
      return this.id ? "edit" : "add";
    },
    isAdd() {
      return this.accion == "add";
    },
    isEdit() {
      return this.accion == "edit";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    direcciones(item) {
      this.clienteObj = item;
      this.direccionesDialog = true;
    },
    verCliente(cliente) {
      this.clienteObj = JSON.parse(JSON.stringify(cliente));
      this.clienteDialog = true;
    },
    mostrarIdioma(s) {
      return mostrarIdioma(s);
    },
    reload() {
      this.getClientes();
    },
    showDialog() {
      this.dialog = true;
      //this.$nextTick(this.$refs.nombreReferencia.focus())
    },
    editItemDialog(item) {
      this.nombreIdiomas = JSON.parse(JSON.stringify(item.nombre));
      this.descripcionIdiomas = JSON.parse(JSON.stringify(item.descripcion));
      this.showDialog();
      this.id = item.id;
    },
    getClientes() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("negocios/getClientesNegocio").finally(() => {
        _vm.loading = false;
      });
    },
    close() {
      this.dialog = false;
      this.$v.$reset();
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      this.clienteDialog = false;
      this.clienteObj = null;
    },
    save() {
      console.log(this.editarCliente);
      this.guardarBotonLoading = true;
      this.$store
        .dispatch("clientes/saveCliente", this.editarCliente)
        .then((r) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Cliente actualizado",
          });
          this.editarDialog = false;
          this.filtrar();
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el cliente: " + e,
          });
        })
        .finally(() => (this.guardarBotonLoading = false));
    },
  },
};
</script>

<style>
</style>